import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@bookips/sds";
import GNBLogo from "../GNBLogo";
const MobileNav = (param)=>{
    let { onSearchClick , onMenuClick  } = param;
    return /*#__PURE__*/ _jsxs("nav", {
        className: "flex h-[52px] items-center justify-between pr-3 pl-5 sm:hidden",
        children: [
            /*#__PURE__*/ _jsx(GNBLogo, {
                variant: "mobile"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: onSearchClick,
                        className: "rounded-md p-2 transition-colors hover:bg-gray-50",
                        children: /*#__PURE__*/ _jsx(Icon.Search_2px, {
                            className: "size-6"
                        })
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: onMenuClick,
                        className: "rounded-md p-2 transition-colors hover:bg-gray-50",
                        children: /*#__PURE__*/ _jsx(Icon.Menu_2px, {
                            className: "size-6"
                        })
                    })
                ]
            })
        ]
    });
};
export default MobileNav;
